import { CustomRulesGeneralWebComponent } from './component/CustomRulesGeneralWebComponent';

export { CustomRulesGeneralWebComponent };
